import React from 'react';

interface MoveForwardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const MoveForwardIcon: React.FC<MoveForwardIconProps> = ({
  width = 110.61,
  height = 122.88,
  color = 'currentColor'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -800 800 800"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Move Forword</title>
      <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
    </svg>
  );
};

export default MoveForwardIcon;
